import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Injectable, Input} from '@angular/core';
import moment from 'moment-timezone';
import {ObservableInput} from 'ngx-observable-input';
import {BehaviorSubject, combineLatest, Observable, Subject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {SideNavComponent} from "./sidenav/sidenav.component";

@Component({
    // tslint:disable-next-line:component-selector
  selector: 'zoned-time',
  templateUrl: './zoned-time.component.html',
  styleUrls: ['./zoned-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ZonedTimeComponent {

  @HostListener('mouseenter') show() { this.showOverlay$.next(true); }
  @HostListener('mouseout') hide() { this.showOverlay$.next(false); }

  @ObservableInput() @Input('time') time$: Observable<moment.Moment | string | number>;
  @ObservableInput() @Input('zone') zone$: Observable<string>;
  // @Input() preferred: 'local' | 'utc' | 'guess' = 'local';
  @Input() format = 'MMM D, LT';
  @Input() source: 'local' | 'utc' = 'local';

  conv$: Observable<ZonedTime>;
  showOverlay$ = new BehaviorSubject(false);
  view$: Observable<'local' | 'utc'>;

  constructor(private options: ZonedTimeOptions) {
    this.view$ = options.defaultView;
    this.conv$ = combineLatest([this.time$, this.zone$]).pipe(
      filter(([time]) => !!time),
      map(([time, zone]) => (typeof time === 'string' || time instanceof String
        ? [moment(time), zone]
        : typeof time === 'number'
          ? [moment.unix(time), zone]
          : [time, zone]) as [moment.Moment, string]),
      map(([time, zone]) => {
        const local = time.tz(!!zone ? zone : moment.tz.guess(), this.source == 'local');
        // const local = !!zone ? moment.tz(time.format('YYYY-MM-DDTHH:mm:ss'), zone) : null;
        const utc = moment.unix(local.unix()).utc();
        const guess = moment.tz(utc, moment.tz.guess());
        return { local, utc, guess };
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class ZonedTimeOptions {
  defaultView: Subject<'local' | 'utc'> = new BehaviorSubject('local');
}

interface ZonedTime {
  local: moment.Moment,
  utc: moment.Moment,
  guess: moment.Moment
}
